import React from 'react';
import {Link} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Link)(() => ({
  whiteSpace: 'normal',
}));

type CollapsableCardLinkProps = React.ComponentPropsWithoutRef<'a'>

/**
 * MUI Link component styled in the SecurSpace way for the CollapsableCard component suite. Used if you want a link styled like a value to the preceding label component
 * @param children children passed through to the internal Link component
 * @param rest The rest of the Link props that will be passed through to the internal Link component
 * @constructor
 */
const CollapsableCardLink = ({children, ...rest}: CollapsableCardLinkProps) => {
  return <Root target={'_blank'} variant={'h6'} underline={'hover'} {...rest}>
    { children }
  </Root>
}

export { CollapsableCardLink };
